<template>
  <div class="filters flex row">
    <span class="mr-2">
      <i class="el-icon-search"></i>
      Cautare:
    </span>

    <ElInput
      style="width:100px;"
      class="mr-1 input-label"
      debounce="1000"
      prefix-icon="el-icon-search"
      placeholder="NR"
      v-model="$parent.filters.number"
      clearable
    />
    <ElInput
      style="width:100px;"
      class="mr-1 input-label"
      debounce="1000"
      prefix-icon="el-icon-search"
      placeholder="GRUP"
      v-model="$parent.filters.groupid"
      clearable
    />
    <div>
      <ElInput
        class="mr-1 input-label"
        prefix-icon="el-icon-search"
        placeholder="Nume"
        v-model="nameInput"
        clearable
      />
      
      <div v-if="$parent.filters.name" style="font-size:10px;">
        Cautare se face dupa grupurile de caractere din nume!
        <!-- <el-checkbox
          label="Cautare fara filtre"
          v-model="$parent.filters.noFilters"
        ></el-checkbox> -->
      </div>
    </div>

    <span class="mx-2">
      <i class="el-icon-question"></i>
      Filtre:
    </span>
    <ResourceSelect
      class="mr-1"
      v-model="$parent.filters.client"
      collection-name="clients"
      placeholder="Toti Clientii"
    />
    <ElSelect clearable class="mr-1" v-model="$parent.filters.stage">
      <ElOption label="Oferta" value="proposal" />
      <ElOption label="Comanda" value="pending" />
      <ElOption label="In Lucru" value="active" />
      <ElOption label="Finalizat" value="completed" />
    </ElSelect>
    <div>
      <ElButton
        class="mr-1"
        :type="$parent.filters.fsc ? 'primary' : 'default'"
        @click="$set($parent.filters, 'fsc', !$parent.filters.fsc)"
        >FSC</ElButton
      >
    </div>
    <div class="mx-2">
      <ElButton
        circle
        type="primary"
        icon="el-icon-close"
        @click="$parent.resetFilters"
        v-if="$parent.hasActiveFilters"
      />
    </div>
      <div>
        <ElButton
          v-if="Object.values($parent.filters).length"
          class="ml-200"
          :type="$parent.filters.notdelivered ? 'primary' : 'default'"
          @click="
            $set($parent.filters, 'notdelivered', !$parent.filters.notdelivered)
          "
          >NELIVRATE</ElButton
        >
      </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      nameInput: this.$parent.filters.name || "",
      nameDebounceTimeout: null,
    };
  },

  watch: {
    nameInput(value) {
      clearTimeout(this.nameDebounceTimeout);

      this.nameDebounceTimeout = setTimeout(() => {
        this.$set(this.$parent.filters, "name", value);
      }, 1000);
    },
  },
};
</script>
<style>
/* nu functionaza debounce */
.input-label {
  display: inline-block;
  width: 200px;
}
</style>
